import tableUnitCardEn from "./locales/en.json";

export const TABLE_UNIT_CARD_NS = "tableUnitCard" as const;

export const TableUnitCardI18n = {
  en: {
    [TABLE_UNIT_CARD_NS]: {
      ...tableUnitCardEn,
    },
  },
};
